export const createNameString = ({
  firstName,
  lastName,
  fallback,
  useFullName = false
} = {}) => {
  const hasName = firstName || lastName;
  const hasBothNames = firstName && lastName;

  let name = fallback || '';

  if (hasName) {
    if (useFullName) {
      name = `${ firstName || '' }${ hasBothNames ? ' ' : '' }${ lastName || '' }`;
    } else {
      name = (firstName || lastName);
    }
  }

  return (name || '').trim();
};